import axios, { AxiosResponse } from 'axios';

import { HSCAN_BACKEND_API_URL } from '../../env';

export interface AddressInfo {
  id?: string;
  userId?: string;
  postalCode: string;
  baseAddress: string;
  detailAddress: string;
  receiverName?: string;
  receiverPhone?: string;
}

export const requestUserAddress = () => {
  return axios.get<AddressInfo>(`${HSCAN_BACKEND_API_URL}/address`);
};

export type RequestEditAddressBody = Pick<
  AddressInfo,
  'postalCode' | 'baseAddress' | 'detailAddress'
>;
export const requestEditAddress = (address: RequestEditAddressBody) => {
  return axios.put<
    AddressInfo,
    AxiosResponse<AddressInfo>,
    RequestEditAddressBody
  >(`${HSCAN_BACKEND_API_URL}/address`, address);
};
